import React, { useEffect, useState } from 'react'

import type * as Dailies from 'services/content/dailies/types'
import * as contentApi from 'services/content'
import DailyItemContainer from '../DailyItem'
import DailyItemList from 'ui-component-library/components/DailyList/DailyItemList'

type Props = {
  contentType: string
  perPage: number
  orderBy: 'date'
  sort: 'desc'
  noResultsFoundText: string
  loadMoreText: string
}

function DailyItemListContainer(props: Props) {
  const {
    contentType,
    perPage,
    orderBy,
    sort,
    noResultsFoundText,
    loadMoreText,
  } = props
  const [isLoading, setIsLoading] = useState(true)
  const [lastEvaluated, setLastEvaluated] = useState<Dailies.LastEvaluated>()
  const [results, setResults] = useState<Dailies.Results>()

  async function fetchDailies() {
    setIsLoading(true)

    const response = await contentApi.fetchDailies({
      lastEvaluated,
      contentType,
      perPage,
      orderBy,
      sort,
    })

    setResults((currentResults) => {
      if (currentResults) {
        return [...currentResults, ...response.dailies]
      } else {
        return response.dailies
      }
    })

    setLastEvaluated(response.lastEvaluated)

    setIsLoading(false)
  }

  useEffect(() => {
    fetchDailies()
  }, [])

  function handleLoadMore() {
    fetchDailies()
  }

  return (
    <DailyItemList
      noResultsFoundText={noResultsFoundText}
      isLoading={isLoading}
      onLoadMore={isLoading ? undefined : handleLoadMore}
      loadMoreText={loadMoreText}
    >
      {results &&
        results.map((result) => (
          <DailyItemContainer key={result.slug} {...result} />
        ))}
    </DailyItemList>
  )
}

export default DailyItemListContainer
